var _defs, _path, _g, _path2, _g2, _g3, _g4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg320X45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "914.04pt",
    height: "127.79pt",
    viewBox: "0 0 914.04 127.79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6562-2.3906v0.46875l3.5469 1.4062 1.0938 0.4375h0.015625v-0.5625l-0.03125-0.015625s-0.71875-0.26562-1.0781-0.40625l-0.078125-0.03125v-2.125l0.03125-0.015625c0.39062-0.14062 1.1406-0.42188 1.1406-0.42188h0.015625v-0.57812h-0.015625s-0.75 0.3125-1.1406 0.45312zm0.67188 0.23438 2.375-0.90625v1.8125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6562-1.7188v1.0469h4.6562v-1.0469c0-1.5625-0.6875-2.5-2.3281-2.5s-2.3281 0.9375-2.3281 2.5zm4.2188 0.51562h-3.7969v-0.46875c0-1.2969 0.51562-1.9844 1.9062-1.9844s1.8906 0.6875 1.8906 1.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6406-3.6406h2.0156v2.4375h-2.0312v0.53125h4.6562v-0.53125h-2.2031v-2.4375h2.2031v-0.51562h-4.6562v0.51562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.4375-3.5312v2.3281h-1.75v-2.1406h-0.4375v2.1406h-1.6094v-2.3125h-0.42188v2.8438h4.6562v-2.875h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.21875-0.4375c0.125-0.20312 0.28125-0.64062 0.28125-1.2031 0-1.0781-0.5625-1.625-1.2969-1.625-0.60938 0-1.0156 0.32812-1.2812 1.0312l-0.21875 0.57812c-0.15625 0.4375-0.375 0.64062-0.76562 0.64062-0.42188 0-0.76562-0.32812-0.76562-1 0-0.48438 0.17188-0.84375 0.29688-1.0469v-0.015625h-0.53125c-0.09375 0.1875-0.21875 0.5625-0.21875 1.0781 0 0.95312 0.53125 1.5312 1.25 1.5312 0.54688 0 0.96875-0.3125 1.2188-0.96875l0.20312-0.57812c0.1875-0.5 0.4375-0.71875 0.85938-0.71875 0.40625 0 0.79688 0.29688 0.79688 1.0625 0 0.5625-0.20312 1-0.375 1.2188v0.015625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6562-0.6875h4.6562v-0.53125h-4.6562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.625-3.4062 1.0781 0.375 2.8281 1.0156-2.7812 0.98438c-0.39062 0.125-1.1406 0.39062-1.1406 0.39062h-0.015625v0.5625h0.015625s0.75-0.26562 1.1406-0.42188l3.5-1.2812v-0.46875l-3.5469-1.3125-1.0938-0.40625h-0.015625v0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6562-2.1562v1.4844h4.6562v-0.53125h-1.9375v-0.95312c0-1.0469-0.48438-1.625-1.3594-1.625-0.89062 0-1.3594 0.57812-1.3594 1.625zm2.2812 0.95312h-1.8594v-0.9375c0-0.71875 0.26562-1.0781 0.9375-1.0781 0.65625 0 0.92188 0.35938 0.92188 1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.4375-3.2188v2.0156h-4.2188v0.53125h4.6562v-2.5625h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.2344-2.4844c0-0.60938 0.21875-0.98438 0.39062-1.1562v-0.015625h-0.54688c-0.15625 0.1875-0.3125 0.59375-0.3125 1.1875 0 1.1562 0.85938 2.1094 2.375 2.1094s2.375-0.95312 2.375-2.1094c0-0.59375-0.17188-1-0.3125-1.1875h-0.54688v0.015625c0.17188 0.17188 0.39062 0.54688 0.39062 1.1562 0 0.85938-0.625 1.5781-1.9062 1.5781s-1.9062-0.71875-1.9062-1.5781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6562-4.7344v0.53125l2.625 1.4844v0.015625l-2.625 1.5v0.51562h4.6562v-0.53125h-3.7812l2.5781-1.4688v-0.046875l-2.5781-1.4531v-0.015625h3.7812v-0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.625-3.6094h3.7344v0.015625l-3.7656 2.4062v0.51562h4.6562v-0.51562h-3.7812l3.7812-2.4062v-0.51562h-4.6562v0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-8-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-4.6562-3.25v3.2031h0.42188v-1.3438h4.2344v-0.53125h-4.2344v-1.3281z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m907.19 127.66v-0.0977h-906.99v-127.36h906.89v127.46h0.1015v-0.0977 0.0977h0.098v-127.66h-907.29v127.76h907.29v-0.10156",
    fill: "#ed1c24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.555 6.9023h1.332l-0.41016-1.082c-0.12109-0.32813-0.21484-0.60157-0.27734-0.81641-0.0547 0.25391-0.12891 0.50781-0.21484 0.75391zm-1.125 1.6055 1.5-3.9062h0.5664l1.5938 3.9062h-0.58984l-0.45312-1.1836h-1.6445l-0.42578 1.1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.023 6.3242h1.1094c0.23438 0 0.41797-0.0234 0.55078-0.0742 0.13282-0.0469 0.23438-0.125 0.30469-0.23047 0.0664-0.10937 0.10156-0.22656 0.10156-0.35156 0-0.18359-0.0664-0.33594-0.19921-0.45703-0.13282-0.12109-0.34375-0.17969-0.63282-0.17969h-1.2344zm-0.51953 2.1836v-3.9062h1.7305c0.34765 0 0.61328 0.0351 0.79687 0.10546 0.17969 0.0703 0.32422 0.19532 0.42969 0.3711 0.10937 0.17578 0.16406 0.375 0.16406 0.58984 0 0.27735-0.0898 0.50781-0.26953 0.69922-0.17969 0.19141-0.45703 0.3125-0.82813 0.36328 0.13672 0.0664 0.23829 0.12891 0.3086 0.19141 0.15234 0.14062 0.29687 0.3125 0.42969 0.52344l0.67578 1.0625h-0.64844l-0.51172-0.8125c-0.15234-0.23438-0.27734-0.41407-0.375-0.53907-0.0977-0.125-0.18359-0.21093-0.26172-0.26172l-0.23437-0.10156c-0.0625-0.0156-0.15625-0.0195-0.28907-0.0195h-0.59765v1.7344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.43 8.5078v-3.4492h-1.2891v-0.45703h3.0938v0.45703h-1.2852v3.4492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.844 7.9609h0.54297v0.54688h-0.54297zm0-2.2852h0.54297v0.54688h-0.54297z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m123.14 44.086v-0.14062h-90.566v-32.863h90.426v33.004h0.14063v-0.14062 0.14062h0.14453v-33.285h-90.992v33.426h90.992v-0.14063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.32 46.668v-0.125h-90.832v28.598h90.957v-28.598h-0.125v0.125h-0.125v28.223h-90.457v-28.098h90.582v-0.125h-0.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.4 108.1c-0.12109-0.28516-0.28125-0.54297-0.48046-0.78125l0.0664-0.1875 1.6562-4.5508 2.0078 5.5195zm-6.4102-2.1719v-5.7422h1.2617c1.7461 0 2.6719 1.043 2.6719 3.0156 0 2.1172-0.50781 2.7266-2.2539 2.7266zm-8.6562 2.1797 4e-3 -8e-3h-0.0508l2.0078-5.5195 0.0234 0.0625 4e-3 -0.0117 1.9922 5.4766zm22.051 4.3476-4.668-12.824-8e-3 -0.0195h-0.27344l-0.9375 2.5703-1.7305 4.7578-0.0586 0.16406-0.1875-0.16406-8e-3 -8e-3c-0.5586-0.45703-1.3047-0.76172-2.2148-0.90625 1.6719-0.39453 2.7774-1.5117 2.7774-2.8438 0-1.9219-1.793-3.2695-4.3672-3.2695h-5.1836v0.27343h1.4492v9.3477l-3.6016-9.8867-4e-3 -0.0156-8e-3 -0.0195h-0.27344l-0.9375 2.5703-3.7383 10.27h-4.0703l7.2383-12.539h-9v4.0273h0.26953v-0.0859c0.0156-1.8242 1.082-3.668 3.4336-3.668h2.8125l-7.082 12.266-0.16016 0.27344h9.9922v-3.4727h-0.27344v0.0898c-0.0156 1.6562-0.97656 2.7109-2.7891 3.0508l-0.0625 0.0117 1.4688-4.0352h4.2148l4e-3 0.0117h0.0156l1.4648 4.0742h-1.3945v0.26954h5.7891v-0.26954h-1.293v-6.2539h1.6797c1.7461 0 2.75 0.76953 2.75 2.1172v1.1406c0 0.125 8e-3 0.30078 0.0195 0.44922v4e-3l0.0508 0.53906-0.73047 2.0039h-1.1914v0.26954h2.5v-0.26954h-1.0195l0.53906-1.4766c0.17579 0.69531 0.4961 1.2227 0.94922 1.5703l0.0742 0.0547c0.40625 0.28125 0.91406 0.42969 1.5 0.42969 0.78906 0 1.3125-0.19922 1.7422-0.66406l0.0625-0.0586-0.17969-0.17968-0.0586 0.0625c-0.36719 0.33593-0.67188 0.47265-1.0508 0.47265-0.62891 0-0.96094-0.78906-0.96094-1.5664v-1.6016c0-0.40234-0.0547-0.78515-0.16406-1.1289h3.2461l1.4883 4.0859h-1.418v0.26954l5.1797 4e-3v-0.27344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.31 112.46h-1.9961v-12.266h1.9961zm-16.66-0.5c-0.61719 0.54297-1.3516 0.73829-2.2969 0.73829-0.94531-4e-3 -1.6797-0.19532-2.3008-0.73829-0.98437-0.84765-1.5039-2.4883-1.5039-5.6562 0-3.168 0.51953-4.8008 1.5039-5.6523 0.6211-0.53906 1.3555-0.73047 2.3008-0.73047 0.94532 0 1.6797 0.19141 2.2969 0.73047 0.96875 0.85156 1.5078 2.4844 1.5078 5.6523 0 3.168-0.53906 4.8086-1.5078 5.6562m24.801-2.9766c0 1.9688-1.1602 3.4766-4.0547 3.4766h-2.1367v-6.2226h0.77344c1.4688 0 2.2969 0.7539 2.2969 1.9688h0.27343v-4.2656h-0.27343c0 1.2578-0.82813 2.0234-2.2969 2.0234h-0.77344v-5.7695h2.1992c2.2617 0 3.168 1.3281 3.168 3.0273h0.27344v-3.3008h-11.594l-3.3711 9.7695-3.6367-9.7695h-3.8125v0.27344h1.5703v4.5c-0.625-2.9062-2.9141-5.0547-5.7031-5.0547-2.8398 0-5.1602 2.2266-5.7344 5.2149v-4.6641l1.6523 4e-3v-0.27344h-5.2383v0.26953h1.6562v5.7578l-5.2109-4e-3v-5.7539h1.6562v-0.26953h-5.2422v0.26953h1.6562v7.2148l1.8359 5.0547h0.0937v-6.2226h5.2109v6.2226h-1.6562v0.27344h5.2383v-0.27344h-1.6523v-4.707c0.57422 2.9883 2.8945 5.2148 5.7344 5.2148 2.7891 0 5.0781-2.1445 5.7031-5.0547v4.5469h-1.8203v0.27344h3.9219v-0.27344l-1.8359-0.0391v-12.227l4.6953 12.844h0.0547l4.3086-12.5v11.922h-1.6992v0.27344h14.043v-3.75"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m893.87 121.8h-70.969c-5.3516 0-9.6836-4.3359-9.6836-9.6797v-96.469c0-5.3477 4.332-9.6797 9.6836-9.6797h70.969c5.3399 0 9.6797 4.332 9.6797 9.6797v96.469c0 5.3438-4.3398 9.6797-9.6797 9.6797",
    fill: "#c4e3de"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-439.27,-368.28)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 463.50101,
    xlinkHref: "#glyph-8-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 459.25415,
    xlinkHref: "#glyph-8-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 454.75436,
    xlinkHref: "#glyph-8-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 449.98828,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 446.16748,
    xlinkHref: "#glyph-8-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 442.55963,
    xlinkHref: "#glyph-8-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 440.73578,
    xlinkHref: "#glyph-8-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 436.76184,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 431.60306,
    xlinkHref: "#glyph-8-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 427.7225,
    xlinkHref: "#glyph-8-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 424.48083,
    xlinkHref: "#glyph-8-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 420.38037,
    xlinkHref: "#glyph-8-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 416.41977,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 412.59894,
    xlinkHref: "#glyph-8-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 407.26041,
    xlinkHref: "#glyph-8-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 403.43961,
    xlinkHref: "#glyph-8-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1298.5601,
    y: 398.72015,
    xlinkHref: "#glyph-8-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1133.5966,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1142.0958,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1155.3395,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1166.307,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1178.6067,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1195.1735,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1203.4731,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1209.7288,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1220.9482,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1244.6832,
    y: 467.66885,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1121.3884,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1132.7606,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1138.7526,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1153.9452,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1155.6938,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1167.0662,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.0586,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.494,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1192.2423,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1209.2347,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1223.2949,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1225.0435,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1244.6998,
    y: 375.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1113.0764,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1128.9316,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1130.8748,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.3101,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1154.2533,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1168.5087,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.1398,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1188.3026,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1190.2456,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1217.2729,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1219.2159,
    y: 380.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1110.8324,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1112.9629,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.5493,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1141.6791,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.2971,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1175.4275,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1184.2456,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1186.3759,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1216.2864,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1218.4163,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1227.9503,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1242.5764,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1244.7067,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1245.6187,
    y: 385.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1118.4564,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1124.5244,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1139.7925,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1141.6165,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.8405,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1158.9084,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.2644,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.0885,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1196.6525,
    y: 390.15286,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1117.3523,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1136.8483,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1138.6523,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1152.9882,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1154.7928,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1171.3732,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.1775,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1192.4542,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1194.2588,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1210.3994,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1212.2041,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1229.0083,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1230.813,
    y: 435.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1126.5283,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1128.3523,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1140.0204,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1141.8444,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1156.6724,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1158.4963,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1173.9923,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 1175.8164,
    y: 445.19696,
    xlinkHref: "#glyph-10-14"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.82 104.41h-1.5391v4.6875h1.5391zm1.5938-1.5976v14.148h-1.5547v-6.2539h-1.5938v6.2578h-1.5742v-14.152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.11 102.81v1.5586h-1.5547v4.7266h1.5312v1.5781h-1.5312v4.7305h1.5352v1.5781h-3.1328v-14.172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.14 116.98h-3.1523v-14.172h3.1523v1.5742h-1.5586v11.023h1.5586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.125 111.26c0.0664-0.21485 0.125-0.40235 0.19141-0.58985l-0.0547-0.20703c-0.41406-0.41797-0.82813-0.83984-1.2422-1.2578l-0.0937-0.082c-0.0391 0.21875-0.082 0.42187-0.10937 0.625l0.0586 0.18359c0.21875 0.24219 0.44531 0.47656 0.66797 0.71484 0.18359 0.19532 0.375 0.39454 0.58203 0.61329m-16.117-2.0078c-0.0703 0.23047-0.125 0.41407-0.18359 0.59375l0.0469 0.19922c0.4375 0.4375 0.875 0.875 1.3086 1.3125l0.0859 0.0703c0.043-0.24609 0.0898-0.47656 0.1289-0.71093l-0.043-0.0937c-0.4375-0.44922-0.8789-0.89453-1.3438-1.3711m15.465 3.5274c0.10547-0.21875 0.21484-0.45703 0.33593-0.69141l-0.0273-0.18359c-0.35547-0.375-0.70312-0.75391-1.0547-1.1328l-0.15234-0.16406c-0.12109 0.30078-0.23438 0.58594-0.33984 0.86719l0.0195 0.11328c0.40234 0.39844 0.80859 0.79297 1.2188 1.1914m-13.863-2.8828c0.10546-0.26171 0.20312-0.51953 0.3125-0.77734l-0.0391-0.19922c-0.37109-0.36719-0.73828-0.74219-1.1055-1.1133l-0.0937-0.0859c-0.1289 0.26953-0.25 0.52344-0.36328 0.78125l0.0274 0.14453c0.11718 0.12891 0.24218 0.25 0.36718 0.375 0.29297 0.28907 0.58985 0.57422 0.89454 0.875m12.375 2.1016c-0.16407 0.27343-0.33985 0.5664-0.51954 0.85937l0.0234 0.1875c0.34766 0.34375 0.6836 0.6875 1.0274 1.0352l0.0859 0.0703c0.21485-0.31641 0.42578-0.625 0.64063-0.9375-0.42188-0.40625-0.83985-0.80859-1.2578-1.2148m-11.805-3.4531c0.1875-0.30859 0.38281-0.6289 0.58203-0.95703-0.41016-0.42578-0.8125-0.84375-1.2227-1.2695-0.22265 0.33594-0.42968 0.65625-0.64453 0.98437 0.42969 0.41797 0.85547 0.82813 1.2852 1.2422m2.6797 2.5938c-0.24219-0.0156-0.48047-0.0234-0.71094-0.0508-0.1211-0.0117-0.15625 0.0156-0.17188 0.14453-0.0586 0.58985-0.1289 1.1797-0.20312 1.7695-0.0156 0.1211-0.0937 0.26172-0.0547 0.35547 0.0391 0.0899 0.19141 0.13672 0.29688 0.19922 0.18359 0.10938 0.36718 0.21875 0.5664 0.33594 0.25391-0.91406 0.29688-1.8203 0.27735-2.7539m-3.5117 5.7227 0.0937 0.0859c1.293 1.2266 2.8555 1.7695 4.6094 1.8008 1.1602 0.0234 2.2812-0.19922 3.3672-0.60547 1.7344-0.65235 3.1992-1.7031 4.4453-3.0664 0.1836-0.19922 0.35547-0.41015 0.50391-0.58594-0.40235-0.42578-0.78906-0.83203-1.1836-1.25l-0.13281 0.15625c-0.8125 1.0312-1.7812 1.8867-2.9258 2.5352-1.1445 0.65234-2.3594 1.0703-3.6875 1.1211-1.0586 0.0391-2.0664-0.15234-2.9883-0.70312-0.31641-0.19141-0.60156-0.41797-0.88672-0.69922 0.41406-0.41797 0.82031-0.82812 1.2188-1.2305h-3.5898v3.6016c0.39062-0.39062 0.76953-0.77343 1.1562-1.1602m8.3242-8.0039c-0.2461 0.0156-0.47266 0.0234-0.71094 0.0391v-1.422h0.71094v1.3828m-2.2578-1.625c-0.33593-0.15234-0.66015-0.29687-0.98828-0.4414-0.26172 0.44531-0.51953 0.8789-0.78125 1.332-0.13281-0.16016-0.26172-0.30078-0.38672-0.44922 0.31641-0.47656 0.625-0.94531 0.94141-1.4258-0.3125-0.16016-0.61719-0.31641-0.93359-0.47657-0.23438 0.41407-0.46485 0.81641-0.69532 1.2305l-0.2539-0.14062c-0.13282 0.22265-0.25782 0.43359-0.38282 0.64844-0.0742 0.125-0.21093 0.26171-0.19921 0.3789 0.0156 0.11719 0.17578 0.22266 0.27343 0.32813l0.21094 0.23047c0.20703 0.21875 0.41406 0.43359 0.62891 0.66015-0.12891 0.14453-0.24219 0.28125-0.36719 0.41016l-0.16797 0.0742c-0.17187 0.0117-0.34375 0-0.5 0v1.2344c0.45703-0.0273 0.88672-0.0469 1.3281-0.0703v3.668h1.1523v-3.7734c0.18359-0.0234 0.33594-0.043 0.49219-0.0625 0.0312 0.10156 0.0664 0.19531 0.0976 0.28906 0.29688-0.0625 0.58203-0.1289 0.87891-0.19531v2.1719l-0.20313 0.0234c-0.11718-0.61718-0.23046-1.2148-0.34375-1.8281-0.25 0.0391-0.48046 0.0742-0.72265 0.10937 0.0859 0.69532 0.16797 1.375 0.2539 2.0586 0.13282-0.0156 0.25391-0.0352 0.40625-0.0547v1.2227c0.91016-0.1836 1.7891-0.35938 2.6797-0.54297-0.0156-0.44141-0.0312-0.8711-0.0469-1.3125-0.28125 0.0547-0.53907 0.10547-0.82032 0.16015v-2.6289h0.75l0.0195 0.1875c0.10546 0.88281 0.19921 1.7734 0.32031 2.6562 0.0625 0.45703 0.23437 0.88672 0.55469 1.2344 0.44921 0.48828 1.0508 0.4375 1.375-0.13672 0.15234-0.25781 0.22656-0.5625 0.32812-0.85156 0.0391-0.10547 0.0117-0.20703-0.0352-0.3125-0.15234-0.33594-0.30078-0.67969-0.44531-1.0234l-0.0586-0.10937c-0.082 0.18359-0.14844 0.36719-0.23828 0.53906l-0.19141 0.19141-0.14844-0.22657c-0.0781-0.29687-0.14843-0.59375-0.19531-0.89843-0.0586-0.38672-0.0937-0.77344-0.14062-1.1992h1.3242v-1.2695c-0.44921 0.0195-0.88281 0.0351-1.3281 0.0547 0.0195-0.49609 0.0391-0.97265 0.0664-1.4453l0.0898-0.0898c0.16016-0.0274 0.32031-0.0391 0.47656-0.0664 0.22266-0.0312 0.44141-0.0742 0.67578-0.11328-0.17187-0.46484-0.32812-0.89453-0.48828-1.332-1.293 0.28516-2.5859 0.42187-3.9141 0.46094v3.8242l-0.0352 4e-3c-0.18359-0.45703-0.36718-0.91797-0.55468-1.3828-0.27735 0.0781-0.53907 0.15625-0.8125 0.23437 0.0469 0.16797 0.0898 0.32032 0.13281 0.48047-0.25 0.0195-0.47656 0.0312-0.73047 0.0469 0.5625-0.78125 1.1055-1.5274 1.6523-2.2852m9.2109 1.7109-0.11719-0.0977c-0.5039-0.5039-1.0078-1.0117-1.5156-1.5234l-0.14063-0.12891c0.0352 0.27344 0.0625 0.50391 0.0977 0.73437l0.082 0.10938c0.46875 0.47266 0.9375 0.94141 1.4102 1.4141l0.10156 0.0899c0.0273-0.1836 0.0547-0.34766 0.082-0.51172zm-17.09 2.6641 0.11718 0.0937c0.52344 0.52735 1.0469 1.0469 1.5703 1.5781l0.0664 0.13672 0.0586-0.0508c-0.0312-0.25-0.0586-0.49609-0.0977-0.74218l-0.0781-0.12891c-0.48829-0.5-0.98047-1-1.4688-1.4961l-0.0899-0.0742c-0.0273 0.18359-0.0547 0.34765-0.0781 0.51562zm11.109-9.8672c0.35156 0.0625 0.70703 0.10547 1.0586 0.1875 1.1523 0.25782 2.1641 0.79297 3.0156 1.6172l0.0586 0.0469c0.39063-0.39063 0.77735-0.78125 1.1953-1.1992v3.6523h-3.6094c0.41406-0.41015 0.81641-0.80469 1.2383-1.2226-0.17578-0.14454-0.3125-0.27344-0.46093-0.38672-1.0039-0.75-2.1484-1.0274-3.3828-0.98047-1.7031 0.0742-3.1992 0.70703-4.5664 1.6875-0.79688 0.57031-1.4922 1.2461-2.0977 2.0156l-0.082 0.0977-0.0156 8e-3c-0.40625-0.41406-0.8125-0.82031-1.2305-1.2461l0.15234-0.19531c1.2812-1.4961 2.7812-2.6875 4.6289-3.4102 0.875-0.34375 1.7812-0.58203 2.7266-0.64844l0.0977-0.0234"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m95.574 114.66 1.4453-1.3867 0.0195 0.70312 1.2422-0.0117 1.2461-8e-3 0.21485-0.0742c0.12109-0.043 0.27734-0.11719 0.35156-0.16797 0.44922-0.3125 0.55859-0.89062 0.28125-1.4961-0.0391-0.0859-0.45312-0.82031-0.92187-1.625-0.46485-0.80859-0.84375-1.4766-0.83204-1.4883l1.1094-0.62485c8e-3 0.0117 0.38672 0.66797 0.84766 1.4609 0.93359 1.6211 1.0156 1.7695 1.1367 2.1406 0.48438 1.4414-0.0937 2.6172-1.4805 3.0195-0.42579 0.1211-0.46875 0.125-1.8555 0.14063l-1.3281 0.0156-0.0234 0.80469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.77 115.2c-0.91015-0.16015-1.5664-0.59375-1.875-1.2305-0.1289-0.27343-0.17187-0.46093-0.1875-0.82422-0.0156-0.38281 0.0234-0.64453 0.16406-1.0586 0.11329-0.34766 0.25391-0.62109 0.80079-1.5664 0.2539-0.43359 0.45703-0.78906 0.45312-0.79296l-0.60156-0.3711 1.9297-0.54297 0.46875 1.9297-0.6875-0.3125c-0.0781 0.10938-0.98047 1.6836-1.0391 1.8203-0.10156 0.23047-0.14843 0.46485-0.13281 0.6875 0.0273 0.47266 0.28516 0.78516 0.79297 0.95703l0.20312 0.0664 3.6875 0.0156v1.2734l-1.8594-4e-3c-1.6602 0-1.8867-8e-3 -2.1172-0.0469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.426 107.55c-0.0234-0.0234 1.5703-2.7969 1.7852-3.1055 0.23437-0.33984 0.58594-0.70312 0.875-0.90234 0.17578-0.1211 0.52734-0.27735 0.75-0.33203 0.55859-0.14063 1.2109 4e-3 1.7344 0.39062 0.25782 0.19141 0.64063 0.60156 0.83594 0.89453 0.0937 0.14453 0.38672 0.63672 0.64844 1.0898 0.26172 0.46093 0.48437 0.83984 0.48437 0.84375l0.625-0.32813-0.49218 1.9336-1.9102-0.54688 0.64062-0.41406c0-0.0352-0.98828-1.7344-1.1094-1.9062-0.30859-0.4336-0.76172-0.66016-1.1641-0.58203-0.32032 0.0625-0.62891 0.28125-0.84375 0.58984-0.0586 0.0781-0.46875 0.78516-0.92188 1.5625-0.45312 0.78125-0.83594 1.4219-0.84765 1.4258-0.3711-0.18359-0.74219-0.38672-1.0898-0.61328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.965 111.55v0.60156h-2.3203v-0.44922l0.82031-0.89062c0.57032-0.61719 0.66407-0.77734 0.66407-1.0664 0-0.29687-0.19922-0.48047-0.58203-0.48047-0.40235 0-0.6836 0.15625-0.82422 0.28907h-8e-3v-0.72266c0.16016-0.10156 0.48438-0.22656 0.9336-0.22656 0.76953 0 1.2461 0.44531 1.2461 1.082 0 0.49609-0.20312 0.83594-0.82031 1.4492l-0.41797 0.41406h1.2812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.68 111.55v0.60156h-2.3203v-0.44922l0.82031-0.89062c0.57031-0.61719 0.66406-0.77734 0.66406-1.0664 0-0.29687-0.19922-0.48047-0.58203-0.48047-0.40234 0-0.68359 0.15625-0.82031 0.28907h-0.0117v-0.72266c0.16015-0.10156 0.48437-0.22656 0.93359-0.22656 0.76953 0 1.2461 0.44531 1.2461 1.082 0 0.49609-0.20313 0.83594-0.82032 1.4492l-0.41797 0.41406h1.2812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.395 118.81c0.0625 0.0156 0.14453 0.0195 0.24219 0.0195 0.37109 0 0.59766-0.17969 0.59766-0.4961 0-0.30078-0.21094-0.46093-0.55079-0.46093-0.13671 0-0.23437 0.0117-0.28906 0.0234zm-0.48828-1.2617c0.17578-0.0312 0.42188-0.0547 0.75781-0.0547 0.35938 0 0.625 0.0781 0.80078 0.22266 0.16016 0.1289 0.26563 0.34375 0.26563 0.59765 0 0.25782-0.082 0.46875-0.23438 0.61328-0.19921 0.19532-0.50781 0.28907-0.85937 0.28907-0.0898 0-0.17578-4e-3 -0.24219-0.0156v1.0195h-0.48828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.383 119.08-0.21484-0.66406c-0.0508-0.16407-0.0977-0.35157-0.13672-0.50782h-8e-3c-0.0391 0.15625-0.0781 0.34375-0.12891 0.50782l-0.21094 0.66406zm-0.77734 0.375-0.23438 0.76562h-0.51171l0.87109-2.707h0.63281l0.87891 2.707h-0.53125l-0.2461-0.76562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.305 118.81c0.0586 0.0156 0.14062 0.0195 0.24219 0.0195 0.36718 0 0.59375-0.17969 0.59375-0.4961 0-0.30078-0.21094-0.46093-0.55079-0.46093-0.13671 0-0.23437 0.0117-0.28515 0.0234zm-0.49219-1.2617c0.17578-0.0312 0.42188-0.0547 0.75781-0.0547 0.35938 0 0.62891 0.0781 0.80078 0.22266 0.16016 0.1289 0.26563 0.34375 0.26563 0.59765 0 0.25782-0.082 0.46875-0.23438 0.61328-0.19531 0.19532-0.50781 0.28907-0.85546 0.28907-0.0937 0-0.17969-4e-3 -0.24219-0.0156v1.0195h-0.49219"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#050606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.738 119.37h-29.652c-3.5391 0-6.4102-2.832-6.4102-6.3008v-10.68h29.652c3.5391 0 6.4102 2.8281 6.4102 6.3008zm-6.4102-17.68h-30.359v11.367c0 3.8711 3.1875 7.0117 7.1172 7.0117h30.363v-11.371c0-3.8711-3.1914-7.0078-7.1211-7.0078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.469 98.867h-0.24219v0.97656h0.25c0.19141 0 0.30078-0.1289 0.30078-0.5 0-0.3164-0.10156-0.48828-0.30859-0.48828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.789 101.69-0.35156-1.3438h-0.21875v1.3438h-0.67187v-3.3828h0.96875c0.57031 0 0.91015 0.3125 0.91015 1 0 0.49219-0.16015 0.76172-0.38672 0.89063l0.4375 1.4922zm-1.5625-2.8203h-0.96093v0.80859h0.76171v0.57032h-0.76171v1.4297h-0.65625v-3.3789h1.6172zm2.3984-1.2734h-4.2383c-0.77734 0-1.4102 0.64063-1.4102 1.4102v3.3828h7.0703v-3.3828c0-0.77734-0.64063-1.4102-1.4219-1.4102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.098 106.11c0 0.10938-0.0312 0.21875-0.082 0.32031l-0.0899 0.10157c-0.0976 0.0586-0.20703 0.0976-0.3164 0.0976h-8.9609c-0.10938 0-0.23047-0.0312-0.32031-0.0976l-0.10157-0.10157c-0.0508-0.10156-0.0781-0.21093-0.0781-0.32031v-0.80078c0-0.34766 0.26953-0.62891 0.59765-0.62891h0.51954l0.71093-0.62109c0.14844-0.12891 0.38282-0.21094 0.6211-0.21094h5.0391c0.23828 0 0.47266 0.082 0.62109 0.21094l0.71094 0.62109h0.51953c0.32813 0 0.59766 0.28125 0.59766 0.62891v0.80078zm-5.3906 2.2891c-0.12109-0.11718-0.12109-0.30859 0-0.41796 0.1211-0.1211 0.3086-0.1211 0.41797 0l0.94141 0.9375c0.12109 0.12109 0.12109 0.3125 0 0.42187l-0.94141 0.94141-0.20703 0.0898-0.21094-0.0898c-0.12109-0.1211-0.12109-0.3125 0-0.42188l0.42969-0.42969h-0.0195c-1.1406 0-2.0703 0.92969-2.0703 2.0703 0 1.1406 0.92968 2.0703 2.0703 2.0703 1.1406 0 2.0703-0.92969 2.0703-2.0703 0-0.26953-0.0508-0.53907-0.16016-0.78907-0.0586-0.15234 0-0.33203 0.16016-0.39062 0.14844-0.0625 0.32813 0 0.39063 0.16016 0.1289 0.32812 0.19921 0.66796 0.19921 1.0195 0 1.4688-1.1992 2.668-2.668 2.668-1.4727 0-2.6719-1.1992-2.6719-2.668s1.1992-2.6719 2.6719-2.6719h0.0273zm5 9.0625c0 0.28907-0.23828 0.52735-0.53125 0.52735h-0.44922c-0.21875 0-0.41015-0.12891-0.48828-0.32031-0.16015 0.20312-0.41015 0.32031-0.6914 0.32031h-4.8984c-0.28125 0-0.53125-0.12891-0.69141-0.32031-0.082 0.1914-0.26953 0.32031-0.48828 0.32031h-0.45312c-0.28907 0-0.52735-0.23828-0.52735-0.52735v-1.9023c0-0.28906 0.23828-0.52734 0.52735-0.52734h0.45312l0.10938 8e-3c-0.21094-2.3398-0.53125-5.9609-0.69141-7.5898-0.0195-0.16797 0.10937-0.32032 0.26953-0.32813 0.17188-0.0234 0.32031 0.10938 0.33203 0.26953 0.23828 2.5078 0.87891 9.6875 0.88672 9.7695 0.0117 0.1211 0.13281 0.21875 0.27344 0.21875h4.8984c0.14062 0 0.26171-0.0976 0.26953-0.21875 0-0.0703 0.64062-7.25 0.89062-9.7695 0.0195-0.17187 0.16016-0.29297 0.33203-0.26953 0.16797 0.0195 0.28907 0.16016 0.26953 0.32813-0.16015 1.6406-0.48046 5.25-0.6914 7.5898l0.10937-8e-3h0.44922c0.29297 0 0.53125 0.23828 0.53125 0.52734zm-2.3789-15.77h-14.41l4.9688 8.4375-4.8711 9.9414h21.434v-11.371c0-3.8711-3.1914-7.0078-7.1211-7.0078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.625 105.21h-5.0391c-0.13672 0-0.25-0.10938-0.25-0.25 0-0.14063 0.11328-0.25 0.25-0.25h5.0391c0.14063 0 0.25 0.10937 0.25 0.25 0 0.14062-0.10937 0.25-0.25 0.25m1.2344 0.0508-0.20313-0.0703-0.79687-0.69922s-0.1211-0.0586-0.23438-0.0586h-5.0391c-0.10938 0-0.19922 0.0274-0.22656 0.0586l-0.80079 0.69922-0.19921 0.0703h-0.63282l-8e-3 0.0391v0.73047h8.7773v-0.76953h-0.6289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.648 110.7c-0.76172 1.1211-0.10938 2.5898 0.66797 3.332 0.71093 0.67968 1.293 0.83984 1.3594 0.85937l0.36328-0.69922 1.0469 2.8789-2.9766 0.59766 0.39843-0.72657-0.39843-0.23047c-1.25-0.82031-1.5234-1.9219-1.6016-2.2695-0.14843-0.60156-0.37109-2.3828 1.1406-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.625 110.75c0.54297 1.2383 2.1328 1.4805 3.1836 1.2109 0.92969-0.24218 1.3672-0.62109 1.4492-0.6914l-0.39843-0.69922 2.9883 0.64844-1.082 2.8398-0.39844-0.71094-0.39063 0.21094c-1.3594 0.62109-2.4375 0.26172-2.7773 0.14063-0.58203-0.19141-2.2109-0.94922-2.5625-2.9609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.918 107.75c-0.21094 1.4805-1.1016 2.1914-1.3789 2.4219-0.48047 0.39063-2 1.3516-3.8711 0.5586 1.3398 0.21094 2.3906-0.98828 2.7383-2.0195 0.3125-0.91797 0.21875-1.5 0.20313-1.5898l-0.79297-0.0391 2.1602-2.1719 1.8125 2.4414-0.82031-0.0508-0.0312 0.44922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.836 106.5c-0.67969 0-1.2383-0.54688-1.2383-1.2383 0-0.69141 0.55078-1.2383 1.2383-1.2383 0.6914 0 1.2422 0.54687 1.2422 1.2383 0 0.6914-0.55079 1.2383-1.2422 1.2383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.539 101.69c-4.4609 0-8.1016 3.6289-8.1016 8.0977 0 4.4609 3.6289 8.1016 8.1016 8.1016 0.23828 0 0.46875-0.0117 0.70703-0.043l0.0508 0.8125 1.4805-1.4297-1.6602-1.2617 0.0586 0.85156c-0.20703 0.0195-0.42969 0.0273-0.64844 0.0273-0.33984 0-0.67968-0.0273-1.0117-0.0664l-0.0274-0.22266-0.76953-6.5586c-0.10937-1.2422 0.59766-1.4297 1.0391-1.25l2.4492 0.98828c0.28125 0.12109 0.41797-0.10938 0.41797-0.10938s0.16406-0.25-0.11719-0.42968c0 0-3.3516-2.2188-4.0586-2.3516-0.97266-0.17968-1.9336 0.61328-2.1523 1.6328l-1.1875 5.8203c-1.0234-1.2305-1.6406-2.8008-1.6406-4.5195 0-3.9024 3.168-7.0625 7.0586-7.0625 2.082 0 3.9492 0.90234 5.25 2.3398l0.73047-0.73828c-1.4805-1.6211-3.6094-2.6406-5.9688-2.6406m-3.6133 10.84c0.11328-0.28906 0.26172-0.26953 0.26172-0.26953s0.14063-0.0312 0.21875 0.25781l1.1602 4.0625c-0.95703-0.28125-1.8399-0.76172-2.5899-1.3906"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#171717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.816 107.09c-0.0195 0.35157-0.0703 0.92188-0.0899 1.1836-0.23047 2.418-0.73828 4.5273-1.5 6.2578-0.32031 0.71875-0.71875 1.4219-1.0703 1.8789l-6.5195-1.3984c0.10156-0.12891 0.19141-0.26172 0.26172-0.3711 1.2695-1.9102 2.0703-4.457 2.3086-7.3672 0.0312-0.41016 0.0586-1.0898 0.0586-1.5898l6.5625 1.3984zm0.47265-0.65625-7.332-1.5625c-0.10937-0.0312-0.23047 0-0.32031 0.082-0.0898 0.0703-0.14063 0.1875-0.12891 0.29688v0.0703c0.0195 0.35156 0 1.3633-0.0508 1.8906-0.23047 2.7891-0.98828 5.2226-2.1914 7.0312-0.14063 0.21093-0.34766 0.5-0.46875 0.64843l-0.10938 0.14063c-0.0781 0.10156-0.10156 0.24219-0.0625 0.35156 0.043 0.11719 0.14063 0.20703 0.27344 0.23828l7.3203 1.5703h0.0781c0.10937 0 0.21875-0.0508 0.28906-0.14063l0.10156-0.11719c0.41016-0.51172 0.85938-1.3008 1.2188-2.1133 0.80078-1.8086 1.332-3.9883 1.5625-6.4883 0.0273-0.33203 0.0898-1.1484 0.0977-1.4102v-0.12109c0.0117-0.17969-0.10938-0.33984-0.28907-0.37891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.309 107.05v0.0391l0.16797 0.0703c0.0625 0.0703 0.0899 0.17187 0.0899 0.28125-8e-3 0.19921-0.16016 0.37109-0.32813 0.37109l-0.17187-0.0703c-0.0586-0.0703-0.0899-0.17188-0.0899-0.28125 0.0117-0.19922 0.16016-0.3711 0.32032-0.3711v-0.0391zm0.31641-0.0195c-0.0781-0.0898-0.19922-0.14063-0.31641-0.14063-0.26953 0-0.5 0.26172-0.51953 0.5625-0.0117 0.16016 0.0391 0.32032 0.13672 0.42969 0.082 0.0899 0.19922 0.14063 0.32031 0.14063 0.26954 0 0.5-0.26172 0.51954-0.5625 0.0117-0.16797-0.0391-0.32032-0.14063-0.42969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.156 115.84-5.8984-1.2773-0.13281 0.0898 0.0937 0.12891 5.8984 1.2812h0.0195l0.10937-0.0898"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.437 101.59c-0.35156 0-0.62109-0.082-0.80078-0.23047-0.17969-0.14844-0.26953-0.41015-0.26953-0.78125v-0.0976h0.67969v0.0898c0 0.17969 0.0312 0.30859 0.10156 0.39844 0.0703 0.082 0.17969 0.1289 0.34765 0.1289 0.1211 0 0.22266-0.0391 0.29297-0.10937 0.0781-0.0703 0.10938-0.16797 0.10938-0.3086 0-0.10156-0.0234-0.1914-0.0508-0.26171-0.0391-0.0703-0.10938-0.12891-0.23047-0.17969-0.39844-0.16016-0.64844-0.26953-0.74219-0.32031-0.0977-0.0469-0.17578-0.11719-0.23828-0.1875-0.0586-0.0703-0.12109-0.16016-0.16016-0.26954-0.0391-0.10156-0.0586-0.22265-0.0586-0.37109 0-0.32031 0.0898-0.55859 0.26953-0.73047 0.17969-0.16797 0.4375-0.25 0.76953-0.25s0.58985 0.082 0.76953 0.23047c0.17969 0.14844 0.26953 0.37891 0.26953 0.69141v0.0781h-0.64843c0-0.32812-0.1211-0.5-0.3711-0.5-0.25781 0-0.39062 0.12891-0.39062 0.39063 0 0.12109 0.0312 0.21875 0.082 0.28125 0.0508 0.0586 0.14062 0.11718 0.26953 0.17968l0.51953 0.23047c0.23047 0.0899 0.39063 0.20703 0.49219 0.34766 0.0977 0.14062 0.14844 0.32031 0.14844 0.53906 0 0.69141-0.39063 1.0312-1.1719 1.0312zm-1.2695-0.0586h-1.9219v-3.3633h1.8789v0.55078h-1.1992v0.78906h1.1328v0.55078h-1.1328v0.90234h1.25v0.54688zm2.3711-4.0625h-4.2226c-0.76953 0-1.4102 0.6289-1.4102 1.4102v3.3594h7.0312v-3.3594c0-0.76953-0.62891-1.4102-1.4102-1.4102",
    fill: "#050606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m912.54 127.79h1.5v-0.25h-1.5z",
    fill: "#ed1c24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg320X45);
export default __webpack_public_path__ + "static/media/320x45.b7ab21cfc041d8b0fb4d1761b79aae47.svg";
export { ForwardRef as ReactComponent };